import { Routes } from '@angular/router';
import { ContactComponent } from './pages/contact/contact.component';
import { MessageListComponent } from './pages/message-list/message-list.component';

export const ContactRoutes: Routes = [
    { path: '', pathMatch: 'full', component: ContactComponent },
    { path: 'poruke', pathMatch: 'full', component: MessageListComponent }
];
